module.exports = __webpack_public_path__ + "img/logo-mobydocs.0148fe77.svg";